import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { useLanguage } from "../LanguageContext";

export const LegalLayout = ({ title, updated, children, backLabel, updatedPrefix }) => {
  const { lang, toggleLang } = useLanguage();
  const location = useLocation();
  const navigate = useNavigate();

  const handleLangToggle = () => {
    toggleLang();
    const path = location.pathname;
    if (path.endsWith("-en")) {
      navigate(path.slice(0, -3));
    } else {
      navigate(path + "-en");
    }
  };

  return (
    <Page>
      <Header>
        <Inner>
          <Brand to="/">
            SWING<span style={{ color: "#4CAF50" }}>MENTOR</span>
          </Brand>
          <RightRow>
            <LangToggle onClick={handleLangToggle}>
              {lang === "en" ? "RU" : "EN"}
            </LangToggle>
            <Back to="/">{backLabel || "← На главную"}</Back>
          </RightRow>
        </Inner>
      </Header>
      <Article>
        <H1>{title}</H1>
        <Updated>{updatedPrefix || "Редакция от"} {updated}</Updated>
        {children}
      </Article>
    </Page>
  );
};

export const Section = ({ title, children }) => (
  <SectionWrap>
    <H2>{title}</H2>
    <SectionBody>{children}</SectionBody>
  </SectionWrap>
);

export const ReqTable = ({ rows }) => (
  <Table>
    <tbody>
      {rows.map(([label, value]) => (
        <tr key={label}>
          <td className="label">{label}</td>
          <td>{value}</td>
        </tr>
      ))}
    </tbody>
  </Table>
);

const Page = styled.main`
  min-height: 100vh;
  background: #fafafa;
  font-family: "Montserrat", sans-serif;
  color: #111;
`;

const Header = styled.header`
  position: sticky;
  top: 0;
  z-index: 10;
  background: rgba(250, 250, 250, 0.92);
  backdrop-filter: blur(6px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
`;

const Inner = styled.div`
  max-width: 760px;
  margin: 0 auto;
  padding: 0 1.25rem;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Brand = styled(Link)`
  font-size: 1.1rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: #111;
  text-decoration: none;
`;

const RightRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`;

const LangToggle = styled.button`
  background: none;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  font-family: inherit;
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  color: rgba(0, 0, 0, 0.55);
  padding: 0.3rem 0.6rem;
  cursor: pointer;
  transition: border-color 0.2s, color 0.2s;

  &:hover {
    border-color: #4caf50;
    color: #4caf50;
  }
`;

const Back = styled(Link)`
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.45);
  text-decoration: none;
  &:hover { color: #4caf50; }
`;

const Article = styled.article`
  max-width: 760px;
  margin: 0 auto;
  padding: 3rem 1.25rem 4rem;
`;

const H1 = styled.h1`
  font-size: 2rem;
  font-weight: 700;
  margin: 0 0 0.4rem;
`;

const Updated = styled.p`
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.4);
  margin: 0 0 2.5rem;
`;

const SectionWrap = styled.section`
  margin-bottom: 2rem;
`;

const H2 = styled.h2`
  font-size: 1.05rem;
  font-weight: 600;
  margin: 0 0 0.75rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
`;

const SectionBody = styled.div`
  font-size: 0.9rem;
  line-height: 1.65;
  color: rgba(0, 0, 0, 0.72);

  p { margin: 0 0 0.75rem; }
  ul { margin: 0 0 0.75rem; padding-left: 1.25rem; }
  li { margin-bottom: 0.35rem; }
  strong { color: #111; }
  a { color: #2e7d32; }
  code {
    background: rgba(0, 0, 0, 0.06);
    padding: 0 0.3em;
    border-radius: 3px;
    font-size: 0.85em;
  }
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 0.88rem;
  margin: 0.5rem 0 0.75rem;

  td {
    border: 1px solid rgba(0, 0, 0, 0.12);
    padding: 0.5rem 0.75rem;
    color: rgba(0, 0, 0, 0.72);
  }
  td.label {
    font-weight: 600;
    color: #111;
    width: 220px;
    background: rgba(0, 0, 0, 0.025);
  }
  @media (max-width: 540px) {
    td.label { width: 130px; }
  }
`;
